import React from "react";
import "./roadClosureWorkPermitAll.css";
import { useParams } from "react-router-dom";

const Template6CS = ({ signatures, formData, workDetails, permitDetails}) => {
  const { formId } = useParams();
  console.log("ID from URL:", formId);
  console.log("ID from signaturessignatures:", signatures);
  console.log("formData in Template6:", formData);
  console.log("workDetails33333", workDetails)
  console.log("permitDetails", permitDetails)

  const normalizeType = (value = "") =>
    value.toLowerCase().replace(/[^a-z0-9]/g, "");

  const getSignatureByType = (...types) =>
    [...(signatures || [])]
      .filter((signature) =>
        types.some(
          (type) => normalizeType(signature.type) === normalizeType(type)
        )
      )
      .sort(
        (first, second) =>
          new Date(second.date_time || 0) - new Date(first.date_time || 0)
      )[0] || {};

  const issuer = getSignatureByType("issuer");
  const safetyOfficer = getSignatureByType(
    "fire_safety_officer",
    "fire & safety",
    "safety officer"
  );
  const oanmHead = getSignatureByType("om_head", "O&M Incharge", "O&M Head");
  console.log("safetyOfficer", safetyOfficer);

  const permitWorkDetails = Array.isArray(workDetails)
    ? workDetails[0] || {}
    : workDetails || {};

  const formatDateTime = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return "";

    const dateStr = date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    });

    const time = date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });

    return `${dateStr}, ${time}`;
};

const formatDateTimes = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '';

  const time = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'UTC',
  });

  const day = String(date.getUTCDate()).padStart(2, '0');
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const year = date.getUTCFullYear();

  const dateStr = `${day}/${month}/${year}`;

  return `${dateStr}, ${time}`;
};


  return (
    <>
      <div className="rc_template-container cold-work">
        <div className="template-container-content">
          <div className="template-container-header">
            <div className="rc-work-table">
              <table className="cold-work-tables">
                <thead>
                  <tr>
                    <th
                      colSpan="2"
                      className="permit-center-align permit-template6 "
                    >
                      जारीकर्ता / Issuer
                    </th>
                    <th
                      colSpan="2"
                      className="permit-center-align permit-template6"
                    >
                      प्राप्तकर्ता / Receiver
                    </th>
                    <th
                      colSpan="2"
                      className="permit-center-align permit-template6"
                    >
                      सुरक्षा अधिकारी / Safety Officer
                    </th>
                  </tr>
                  <tr>
                    <th className="permit-center-align permit-template6">
                      नाम और पद <br /> Name & Designation
                    </th>
                    <th className="permit-center-align permit-template6">
                      हस्ताक्षर <br /> Signature
                    </th>
                    <th className="permit-center-align permit-template6">
                      नाम और पद <br /> Name & Designation
                    </th>
                    <th className="permit-center-align permit-template6">
                      हस्ताक्षर <br />
                      Signature
                    </th>
                    <th className="permit-center-align permit-template6">
                      नाम <br /> Name{" "}
                    </th>
                    <th className="permit-center-align permit-template6">
                      हस्ताक्षर <br /> Signature
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="permit-row">
                    <td className="permit-center-align">
                      {issuer.name || ""} <br />{issuer.designation ? `(${issuer.designation})` : ""} <br />
                      {formatDateTime(issuer.date_time)}
                    </td>
                    <td className="permit-center-align"></td>
                    <td className="permit-center-align">
                    {permitWorkDetails.receiver_name || ""} <br />
                    {formatDateTimes(
                      permitWorkDetails.issued_date || permitWorkDetails.created_at
                    )}
                    </td>
                    <td className="permit-center-align"></td>
                    <td className="permit-center-align">
                      {safetyOfficer.name || ""}
                      <br />
                      {formatDateTime(safetyOfficer.date_time)}
                    </td>
                    <td className="permit-center-align"></td>
                  </tr>

                  <tr className="hot-permit-row">
                    <th colSpan='6' className="permit-center-align">अनुमोदन / Approved</th>
                  </tr>
                  <tr>
                    <th className="permit-center-align permit-template6">
                      नाम और पद <br /> Name & Designation
                    </th>
                    <th>{oanmHead.name || ""} <br/> {oanmHead.designation ? `(${oanmHead.designation})` : ""}</th>
                    <th className="permit-center-align permit-template6">
                      हस्ताक्षर <br /> Signature
                    </th>
                    <th></th>
                    <th className="permit-center-align permit-template6">
                    दिनांक <br />
                      Date:
                    </th>
                    <th className="permit-center-align permit-template6">
                    {formatDateTime(oanmHead.date_time)}
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Template6CS;
